import { createSharedComposable } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { FolderSettingService } from '@/domains/detail/folder/types/folder-setting-service.interface';
import { computed, ref } from 'vue';
import { FolderSortService } from '@/domains/detail/folder/services/folder-sort-service.interface';
import { useDetailRoute } from './use-detail-route';
import { useSpace } from '@/presentation/composables/space/use-space';
import { useDetailRouter } from './use-detail-router';
import { DATA_TYPE_TO_FIELD_MAP } from '@/domains/base/constants/data-type';
export const useFolderSetting = createSharedComposable(() => {
    const folderSettingService = injectService(FolderSettingService);
    const folderSortService = injectService(FolderSortService);
    const { dataType, spaceId, folderId } = useDetailRoute();
    const { updateRouterSort } = useDetailRouter();
    const { spaceSetting } = useSpace();
    const folderSetting = ref(folderSettingService.folderSetting);
    folderSettingService.subscribe((newVal) => {
        folderSetting.value = newVal;
    });
    function resetFolderSort(spaceSetting) {
        const dataTypeField = DATA_TYPE_TO_FIELD_MAP[dataType.value];
        const spaceSort = spaceSetting?.data_sort?.[dataTypeField];
        folderSettingService.updateCurrentSort(folderSortService.getSort() || spaceSort);
    }
    const initFolderSort = () => {
        folderSortService.init({
            folderId: folderId.value,
            spaceId: spaceId.value,
            dataType: dataType.value,
        });
        resetFolderSort(spaceSetting.value);
    };
    /**
     * 数据类型和视图类型初始化文件夹设置信息
     * @param dataType 数据类型
     * @param viewType 视图类型
     */
    const initFolderSetting = () => {
        initFolderSort();
    };
    const updateFolderSetting = (folderSetting) => {
        folderSettingService.updateFolderSetting(folderSetting);
    };
    const updateFolderSort = (sort) => {
        // 更新路由
        updateRouterSort(sort);
        // 更新localStorage
        folderSortService.setSort(sort);
        // 更新model
        folderSettingService.updateCurrentSort(sort);
    };
    const visibleFields = computed(() => {
        return folderSetting.value?.visible_fields || [];
    });
    const freezeFields = computed(() => {
        return folderSetting.value?.freeze_fields || [];
    });
    const filterFields = computed(() => {
        return folderSetting.value?.filter_fields || [];
    });
    const currentSort = computed(() => {
        const dataTypeField = DATA_TYPE_TO_FIELD_MAP[dataType.value];
        return folderSetting.value?.current_sort || spaceSetting.value?.data_sort?.[dataTypeField] || '';
    });
    const collapseSetting = computed(() => {
        return folderSetting.value?.collapse_setting;
    });
    return {
        folderSetting,
        visibleFields,
        freezeFields,
        filterFields,
        currentSort,
        collapseSetting,
        updateFolderSetting,
        initFolderSetting,
        initFolderSort,
        updateFolderSort,
        resetFolderSort,
    };
});
